import { FloorIcon } from "components/atoms/Icon";
import { Header } from "components/atoms/Typography";
import { BuildingSectionProps, floorFieldValues } from "../BuildingConstruction.constants";
import BuildingSectionBody from "./BuildingSectionBody";

function BuildingFloor(props: BuildingSectionProps) {
    return (
        <>
            <div className="construction-sidebar__body__header">
                <FloorIcon />
                <Header size="medium">Floor</Header>
            </div>
            <BuildingSectionBody {...props} fields={floorFieldValues} />
        </>
    );
}

export default BuildingFloor;
